/**
 * Vue Router 3 may reject navigations with `name === 'NavigationDuplicated'`
 * (same route) or message containing "Navigation cancelled". Wrap router
 * `push`/`replace` promises so these cases do not surface as unhandled
 * rejections; other errors are rethrown.
 */
export const navUtil = {
  ignoreDuplicateNavigation(p: Promise<unknown>): Promise<unknown> {
    return p.catch((err: { name?: string }) => {
      if (err?.name !== 'NavigationDuplicated') throw err;
    });
  },

  ignoreDuplicateOrCancelledNavigation(p: Promise<unknown>): Promise<unknown> {
    return p.catch((err: Error & { name?: string }) => {
      if (err?.name === 'NavigationDuplicated') return;
      if (String(err?.message || '').includes('Navigation cancelled')) return;
      throw err;
    });
  }
};
